import ToolPage from '../pages/tool/page'

export const toolRoutes = [{ path: '/tool', element: <ToolPage /> }]
